import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";

import NewsCategorySelector from "^/Components/ScrivitoExtensions/NewsCategorySelector";

Scrivito.provideEditingConfig("GlobalNewsWidget", {
  title: "GlobalNewsWidget",
  attributes: localizeAttrList(
    [
      "eventCount",
      "eventLink",
      "eventHeadline",
      "newsHeadline",
      "newsCountPerPage",
    ],
    "GlobalNewsWidget"
  ),
  properties: [
    "eventHeadline",
    "eventCount",
    "eventLink",
    "newsHeadline",
    "newsCountPerPage",
  ],
  propertiesGroups: [
    {
      title: "Category filter",
      key: "categories",
      component: ({ widget }) => (
        <NewsCategorySelector
          content={widget}
          lang={widget.obj().language()}
          currentValues={widget.get("categoryFilter")}
          attributeName="categoryFilter"
        />
      ),
    },
  ],
  initialContent: {
    newsCountPerPage: 30,
    eventCount: 5,
    eventHeadline: "Veranstaltungen",
    newsHeadline: "News",
  },
});
